import React, { useEffect, useState } from "react";
import Styles from "./ListingDetails.module.css";
import { openBilateralChat } from "../../Banking/CreateEdit/helpers";
import { useDispatch, useSelector } from "react-redux";
import TermsConditionModal from "../../Banking/TermsConditionModal/TermsConditionModal";
import ViewDoc from "../../Banking/ViewDoc/ViewDoc";
import UpdateLedger from "../../Banking/UpdateLedger/UpdateLedger";
import ViewInjectDrawal from "../../Banking/ViewInjectDrawal/ViewInjectDrawal";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import {
  fetchAllBankingListings,
  fetchDocumentUrlByLedgerId,
} from "../../../../Redux/Slices/bankingSlice";
import LedgerHistory from "../../Banking/LedgerHistory/LedgerHistory";

const DiscomDetails = ({ ele }) => {
  const bankingList = useSelector(
    (state) => state?.bankingSlice?.matchmakingData
  );

  const dispatch = useDispatch();

  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [ledgerModalOpen, setLedgerModalOpen] = useState(false);
  const [viewInjectDrawalOpen, setViewInjectDrawalOpen] = useState(false);

  const [selectedConnection, setSelectedConnection] = useState(null);
  const [selectedCounterparty, setSelectedCounterparty] = useState(null);
  const [activeLedgerData, setActiveLedgerData] = useState([]);

  const [viewDocConnectionId, setViewDocConnectionId] = useState(null);
  const [activeViewCounterparty, setActiveViewCounterparty] = useState(null);

  const [updateLedgerConnectionId, setUpdateLedgerConnectionId] =
    useState(null);
  const [updateLedgerSelfListingId, setUpdateLedgerSelfListingId] =
    useState(null);
  const [updateLedgerConnectionData, setUpdateLedgerConnectionData] =
    useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewDocumentId, setPreviewDocumentId] = useState(null);

  const [viewInjectDrawalData, setViewInjectDrawalData] = useState([]);

  const activeListingId =
    bankingList?.selfListing?.id ||
    bankingList?.selfListing?.bankingListing?.id ||
    ele?.id;

  const data = bankingList?.matches?.[0];

  const connectionDetail = ele?.connectionDetails?.[0];
  const counterpartyBase = {
    id: ele?.id,
    name: ele?.name,
    companyName: ele?.companyName,
    userId: ele?.userId,
    connectionStatus: connectionDetail?.status || ele?.status,
    bankingFactor: ele?.bankingFactor,
    settlementRate: ele?.settlementRate,
    maxInjectQuantity: ele?.maxInjectQuantity,
    minInjectQuantity: ele?.minInjectQuantity,
    maxDrawalQuantity: ele?.maxDrawalQuantity,
    minDrawalQuantity: ele?.minDrawalQuantity,
    bankingSlotInjects: ele?.bankingSlotInjects,
    bankingSlotDrawls: ele?.bankingSlotDrawls,
    injectMaxRange: ele?.injectMaxRange,
    injectMinRange: ele?.injectMinRange,
    drawalMaxRange: ele?.drawalMaxRange,
    drawalMinRange: ele?.drawalMinRange,
    ...connectionDetail,
  };

  useEffect(() => {
    dispatch(fetchAllBankingListings({ size: 100 })); 
  }, [dispatch]);

  const handleOpenTerms = () => {
    const connectionPayload = connectionDetail
      ? {
          ...connectionDetail,
          id: connectionDetail?.id || connectionDetail?.connectionId,
          connectionId: connectionDetail?.id || connectionDetail?.connectionId,
          selfListing: ele,
          counterPartyListings: [counterpartyBase],
        }
      : { id: ele?.id, connectionId: ele?.id, selfListing: ele };

    setSelectedConnection(connectionPayload);
    setSelectedCounterparty(counterpartyBase);
    setActiveLedgerData(ele?.connectionDetails || []);
    setTermsModalOpen(true);
  };

  const handleCloseTerms = () => {
    setTermsModalOpen(false);
  };

  const handleOpenDocs = () => {
    const docConnectionId =
      connectionDetail?.id || connectionDetail?.connectionId || ele?.id;

    setViewDocConnectionId(docConnectionId);
    setActiveViewCounterparty(counterpartyBase);
    setActiveLedgerData(ele?.connectionDetails || []);
    setViewDocModalOpen(true);
  };

  const handleCloseDocs = () => {
    setViewDocModalOpen(false);
    setViewDocConnectionId(null);
    setActiveViewCounterparty(null);
  };

  const handleOpenLedger = () => {
    const ledgerConnectionId =
      connectionDetail?.id || connectionDetail?.connectionId || ele?.id;
    const selfListingId =
      bankingList?.selfListing?.id ||
      bankingList?.selfListing?.bankingListing?.id ||
      connectionDetail?.bankingListingId ||
      ele?.id;

    const connectionDataWithId = {
      ...(connectionDetail || {}),
      id: ledgerConnectionId,
      connectionId: ledgerConnectionId,
      selfListing: ele,
      counterPartyListings: [counterpartyBase],
      ledgers: connectionDetail?.ledgers || ele?.ledgers || [],
    };

    setUpdateLedgerConnectionId(ledgerConnectionId);
    setUpdateLedgerSelfListingId(selfListingId);
    setUpdateLedgerConnectionData(connectionDataWithId);
    setLedgerModalOpen(true);
  };

  const handleCloseLedger = () => {
    setLedgerModalOpen(false);
    setUpdateLedgerConnectionId(null);
    setUpdateLedgerSelfListingId(null);
    setUpdateLedgerConnectionData(null);
  };

  const handleLedgerUpdated = () => {
    handleCloseLedger();
  };

  const handleOpenRequisitions = () => {
    setViewInjectDrawalData([ele]);
    setViewInjectDrawalOpen(true);
  };

  const handleCloseRequisitions = () => {
    setViewInjectDrawalOpen(false);
    setViewInjectDrawalData([]);
  };

  const handleViewDocument = async (docId) => {
    if (!docId) return;

    try {
      const resultAction = await dispatch(fetchDocumentUrlByLedgerId(docId));
      if (fetchDocumentUrlByLedgerId.fulfilled.match(resultAction)) {
        const url = resultAction.payload?.url || resultAction.payload;
        if (url) {
          setPreviewFileUrl(url);
          setPreviewDocumentId(docId);
          setPreviewOpen(true);
        }
      }
    } catch (error) {
      console.error("Error viewing document", error);
    }
  };
  return (
    <>
      <div className={Styles.bankingContianer}>
        <div className={`display_flex_row ${Styles.listingTopContainer}`}>
          <div className={`display_flex_column_gap_4`}>
            <div className={Styles.displayName}>
              {ele?.companyDetails?.displayName}
            </div>
            <div className={Styles.companyDetails}>{ele?.name}</div>
          </div>
          <div className="pending">{ele?.status}</div>
        </div>
        <div className={`display_flex_row ${Styles.injDrawContainer}`}>
          <div className={`display_flex_column_gap_4 ${Styles.detailBox}`}>
            <div>Injection Range</div>
            <div>
              {ele?.bankingSlotInjects?.[0]?.dateStartAt} to{" "}
              {ele?.bankingSlotInjects?.[0]?.dateEndAt}
            </div>
            <div>
              {ele?.bankingSlotInjects?.[0]?.slotStartAt} to{" "}
              {ele?.bankingSlotInjects?.[0]?.slotEndAt}
            </div>
          </div>

          <div className={`display_flex_column_gap_4 ${Styles.detailBox}`}>
            <div>Drawal Range Range</div>
            <div>
              {ele?.bankingSlotDrawls?.[0]?.dateStartAt} to{" "}
              {ele?.bankingSlotDrawls?.[0]?.dateEndAt}
            </div>
            <div>
              {ele?.bankingSlotDrawls?.[0]?.slotStartAt} to{" "}
              {ele?.bankingSlotDrawls?.[0]?.slotEndAt}
            </div>
          </div>
          <div className={`display_flex_column_gap_4 ${Styles.detailBox}`}>
            <div>Banking Factor (%)</div>
            <div>{ele?.bankingFactor || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_4 ${Styles.detailBox}`}>
            <div>Settlement Rate (₹/KWh)</div>
            <div>{ele?.settlementRate || "-"}</div>
          </div>
        </div>
        <div
          className={Styles.viewReqs}
          onClick={handleOpenRequisitions}
          style={{ cursor: "pointer" }}
        >
          View All Requisitions
        </div>
        <div className={Styles.buttonContainer}>
          <div onClick={handleOpenTerms} style={{ cursor: "pointer" }}>
            View T&C
          </div>
          <div onClick={handleOpenDocs} style={{ cursor: "pointer" }}>
            View Docs
          </div>
          <div onClick={handleOpenLedger} style={{ cursor: "pointer" }}>
            View Ledger
          </div>
          <div
            onClick={() =>
              openBilateralChat(dispatch, {
                header: ele?.name,
                fromUser: bankingList?.selfListing?.name,
                toUser: ele?.name,
                hidechat: true,
              })
            }
          >
            View Chat
          </div>
        </div>
      </div>
      <TermsConditionModal
        open={termsModalOpen}
        handleClose={handleCloseTerms}
        connectionId={
          selectedConnection?.id || selectedConnection?.connectionId
        }
        counterpartyId={selectedCounterparty?.id}
        onAccept={handleCloseTerms}
        onDecline={handleCloseTerms}
        currentUserListingIds={activeListingId}
        activeListingId={activeListingId}
        termsData={activeLedgerData}
        activeData={selectedConnection}
        activeCounterparty={selectedCounterparty}
        viewOnly={true}
        isApprovalMode={false}
      />

      <ViewDoc
        open={viewDocModalOpen}
        handleClose={handleCloseDocs}
        connectionId={viewDocConnectionId}
        viewDocData={activeLedgerData}
        activeCounterparty={activeViewCounterparty}
      />

      <LedgerHistory
        open={ledgerModalOpen}
        handleClose={handleCloseLedger}
        connectionId={updateLedgerConnectionId}
        viewDocData={data}
        activeCounterparty={updateLedgerConnectionData}
      />

      <ViewInjectDrawal
        open={viewInjectDrawalOpen}
        handleClose={handleCloseRequisitions}
        data={viewInjectDrawalData}
        termsDocumentId={
          ele?.termsDocumentId ||
          connectionDetail?.termsDocumentId ||
          connectionDetail?.partyOneAgreementDocumentId
        }
        onViewDocument={handleViewDocument}
      />

      <PreviewModal
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setPreviewFileUrl(null);
          setPreviewDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={previewDocumentId}
      />
    </>
  );
};

export default DiscomDetails;
